module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nl-filter-bar"
  }, [_c('label', {
    staticClass: "nl-filter-label"
  }, [_vm._v("Describe your target audience")]), _vm._v(" "), _c('div', {
    staticClass: "nl-filter-bar-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputText),
      expression: "inputText"
    }],
    staticClass: "form-control nl-filter-input",
    attrs: {
      "placeholder": "e.g. Women 18-30 on WhatsApp in Kenya who completed onboarding but haven't been active in 30 days",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.inputText)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary nl-filter-send",
    attrs: {
      "type": "button",
      "disabled": _vm.loading || !_vm.inputText.trim()
    },
    on: {
      "click": _vm.send
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-magic"
  }), _vm._v("\n      Generate\n    ")])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "nl-filter-feedback nl-filter-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Generating filters from your description...\n  ")]) : (_vm.lastMessage) ? _c('div', {
    staticClass: "nl-filter-feedback"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.lastMessage) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.unsupported.length) ? _c('div', {
    staticClass: "nl-filter-unsupported"
  }, _vm._l((_vm.unsupported), function(note, i) {
    return _c('div', {
      key: i
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }), _vm._v(" " + _vm._s(note))])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-645a5af2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audience-builder/ai-audience/NlFilterBar.vue
// module id = Y5ER
// module chunks = 1